import React from 'react'
import { FolderTree } from 'lucide-react'
import GenericTabelaPage from '../../components/tabelas/GenericTabelaPage'
import { categoriasApi } from '../../api/tabelasBasicas'

const CategoriasPage: React.FC = () => {
  return (
    <GenericTabelaPage
      titulo="Categorias"
      breadcrumb="Tabelas › Básicas"
      icon={<FolderTree size={17} />}
      cdMaxLen={12}
      nmMaxLen={60}
      api={categoriasApi}
    />
  )
}

export default CategoriasPage
